import { render, staticRenderFns } from "./UnderDevelopment.vue?vue&type=template&id=47a123ba&scoped=true&"
var script = {}
import style0 from "./UnderDevelopment.vue?vue&type=style&index=0&id=47a123ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a123ba",
  null
  
)

export default component.exports